import { shouldSkipForceLogout } from "app/routes";

/**
 * Force logout and redirect to login page with session expired message
 * Called when any API returns 401 Unauthorized
 */
const forceLogout = () => {
  // Set session expired flag BEFORE removing token to avoid race condition
  // (PrivateRoute may redirect via React Router when token is removed)
  sessionStorage.setItem("session_expired", "true");
  localStorage.removeItem("token");
  window.location.href = "/login";
};

export const request = async (url, options = {}) => {
  // Default headers
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  // Get token from localStorage (using your existing pattern)
  const token = localStorage.getItem("token");
  if (token) {
    defaultHeaders.Authorization = `Token ${token}`;
  }

  // Merge headers - if specific headers are passed, they override defaults
  // Special case: if body is FormData, don't set Content-Type (let browser handle it)
  let finalHeaders = { ...defaultHeaders };

  if (options.headers) {
    finalHeaders = { ...defaultHeaders, ...options.headers };
  }

  // If body is FormData, remove Content-Type to let browser set it with boundary
  if (options.body instanceof FormData) {
    delete finalHeaders["Content-Type"];
  }

  const config = {
    ...options,
    headers: finalHeaders,
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      // Handle 401 Unauthorized - force logout (except on public/standalone routes)
      if (
        response.status === 401 &&
        !shouldSkipForceLogout(window.location.pathname)
      ) {
        forceLogout();
        // Return a promise that never resolves - page will redirect before it matters
        // This prevents any error UI from flashing before the redirect
        return new Promise(() => {});
      }

      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch {
        errorData = { message: errorText };
      }
      errorData.status = response.status;
      throw errorData;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      return await response.text();
    }
  } catch (error) {
    throw error;
  }
};
